export const phoneRegex = /^\d{10,15}$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;


export const mainMenuOptions = [
  "Help Me With My Book Idea & Planning",
  "Help Me Structure My Book",
  "Help Me Edit & Refine My Book",
  "Help Me With My Book Cover Design",
  "More Options",
];

export const moreOptionsSubmenu = [
  "How to Market Your Book",
  "Self-Publishing Your Book (Lulu.com)",
  "Publish on Amazon (Step-by-Step Guide)",
  "Back to Main Menu",
];